import { Typography, Paper, Box } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";

const BAD_COLOR = "rgba(239,68,68,0.7)";
const GOOD_COLOR = "#FF8904";

const rows = [
  { label: "Tempo de pesquisa", bad: "30-60 minutos", good: "< 3 segundos" },
  { label: "Qualidade das fontes", bad: "Variável e subjetiva", good: "Apenas evidência nível A-B" },
  { label: "Interações verificadas", bad: "Manual, sujeito a erro", good: "Automático via CYP450" },
  { label: "Protocolos atualizados", bad: "Depende do médico", good: "Protocolos e diretrizes clínicas em tempo real" },
  { label: "Segurança farmacológica", bad: "Memória + bula", good: "18k+ artigos indexados" },
  { label: "Confiança na prescrição", bad: "Incerta", good: "Score de evidência visível" },
];

export default function ComparisonSection() {
  return (
    <section className="relative z-10 px-6 md:px-12 pb-20 md:pb-28">
      <div className="text-center mb-14">
        <Typography
          sx={{
            color: "#FF8904",
            fontWeight: 700,
            fontSize: "0.8rem",
            letterSpacing: "0.15em",
            marginBottom: "12px",
          }}
        >
          COMPARATIVO
        </Typography>
        <Typography
          variant="h4"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            fontFamily: "Oxanium, sans-serif",
            letterSpacing: "-0.02em",
            fontSize: { xs: "1.5rem", md: "2rem" },
          }}
        >
          Sem IA vs. Com Dr. Weedy
        </Typography>
      </div>

      <div className="max-w-4xl mx-auto">
        <Paper
          elevation={0}
          sx={{
            background:
              "linear-gradient(135deg, rgba(26, 49, 60, 0.6) 0%, rgba(4, 9, 10, 0.8) 100%)",
            backdropFilter: "blur(16px)",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "24px",
            overflow: "hidden",
          }}
        >
          {/* Desktop / tablet landscape: real table */}
          <table className="hidden md:table w-full border-collapse">
            <thead>
              <tr className="border-b border-white/10">
                <th className="text-left p-5">
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.4)",
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.03em",
                    }}
                  >
                    Critério
                  </Typography>
                </th>
                <th className="text-left p-5">
                  <Typography
                    sx={{
                      color: BAD_COLOR,
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.03em",
                    }}
                  >
                    Sem IA
                  </Typography>
                </th>
                <th className="text-left p-5">
                  <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <BoltOutlinedIcon sx={{ color: GOOD_COLOR, fontSize: "16px" }} />
                    <Typography
                      sx={{
                        color: GOOD_COLOR,
                        fontWeight: 700,
                        fontSize: "0.8rem",
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                      }}
                    >
                      Com Dr. Weedy
                    </Typography>
                  </Box>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr
                  key={row.label}
                  className="border-b border-white/5 last:border-b-0"
                >
                  <td className="p-5 align-top">
                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.85)",
                        fontWeight: 600,
                        fontSize: "0.95rem",
                      }}
                    >
                      {row.label}
                    </Typography>
                  </td>
                  <td className="p-5 align-top">
                    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <CancelOutlinedIcon sx={{ color: BAD_COLOR, fontSize: "20px" }} />
                      <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: "0.95rem" }}>
                        {row.bad}
                      </Typography>
                    </Box>
                  </td>
                  <td className="p-5 align-top">
                    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <CheckCircleOutlinedIcon sx={{ color: GOOD_COLOR, fontSize: "20px" }} />
                      <Typography
                        sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 500, fontSize: "0.95rem" }}
                      >
                        {row.good}
                      </Typography>
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Mobile: card-per-row (a real <table> gets too cramped below md) */}
          <div className="md:hidden divide-y divide-white/10">
            {rows.map((row) => (
              <div key={row.label} className="p-5">
                <Typography
                  sx={{ color: "#ffffff", fontWeight: 700, fontSize: "1rem", marginBottom: "12px" }}
                >
                  {row.label}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                  <CancelOutlinedIcon sx={{ color: BAD_COLOR, fontSize: "18px" }} />
                  <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: "0.9rem" }}>
                    {row.bad}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <CheckCircleOutlinedIcon sx={{ color: GOOD_COLOR, fontSize: "18px" }} />
                  <Typography
                    sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 500, fontSize: "0.9rem" }}
                  >
                    {row.good}
                  </Typography>
                </Box>
              </div>
            ))}
          </div>
        </Paper>
      </div>
    </section>
  );
}
